import { AnyAction } from 'redux';
import { SET_NEWS_LIST_FILTER } from '../constants';

export interface NewsListState {
  title: string;
  introduction: string;
  numberOfNewsPerPage: number;
  news: any;
  pagination: any;
  newsTypes: any;
  years: string[];
  months: string[];
  selectedType: number;
  selectedYear: string;
  selectedMonth: string;
  selectedPage: number;
}

const defaultState: NewsListState = {
  title: '',
  introduction: '',
  numberOfNewsPerPage: 10,
  news: null,
  pagination: null,
  newsTypes: null,
  years: [],
  months: [],
  selectedType: 0,
  selectedYear: '',
  selectedMonth: '',
  selectedPage: 1,
};

export default (
  state = defaultState,
  action: AnyAction
): NewsListState => {
  const { type, payload } = action;
  switch (type) {
    case SET_NEWS_LIST_FILTER:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
